var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "4 -8 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1862_8776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.5C19.1944 18.5 23 14.6944 23 10C23 5.30558 19.1944 1.5 14.5 1.5C9.80558 1.5 6 5.30558 6 10C6 14.6944 9.80558 18.5 14.5 18.5Z",
    stroke: "url(#paint0_linear_1862_8776)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.498 14.1558C16.7944 14.1558 18.656 12.2942 18.656 9.99784C18.656 7.70144 16.7944 5.83984 14.498 5.83984C12.2016 5.83984 10.34 7.70144 10.34 9.99784C10.34 12.2942 12.2016 14.1558 14.498 14.1558Z",
    fill: "url(#paint1_linear_1862_8776)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1862_8776",
    x: 0.5,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1862_8776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1862_8776",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1862_8776",
    x1: 21.011,
    y1: 3.88,
    x2: 8.363,
    y2: 17.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1862_8776",
    x1: 17.6831,
    y1: 7.00408,
    x2: 11.496,
    y2: 13.4656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.a2b2e8b06434f43dacd98861b75fbabf.svg";
export { ForwardRef as ReactComponent };